<template>
  <section class="invest-entrepreneurship">
    <div class="invest-entrepreneurship__content">
      <div class="invest-entrepreneurship__image">
        <p class="invest-entrepreneurship__quote --fade-in-right" data-vertical-ivp-class="--animate">
          Item 9 Labs brings innovative technologies,
          award-winning flower & concentrates for those who can feel
          & taste the difference.
        </p>
      </div>
      <div class="invest-entrepreneurship__text">
        <h3 class="--fade-in-left" data-vertical-ivp-class="--animate">INVEST IN CANNABIS ENTREPRENEURSHIP</h3>
        <h1>The Problem with Cannabis Expansion.</h1>
        <p>
          The complexities of operating a cannabis business make it difficult for small,
          independent dispensaries to understand and stay on top of all the varying
          regulations and everyday challenges of managing and operating a compliant and
          successful dispensary.<br/><br/>In short, here’s why we believe in keeping cannabis local:
        </p>
        <ul class="--fade-in-left" data-vertical-ivp-class="--animate">
          <li>Multi-state operators (MSOs) are dominating across states</li>
          <li>Single-unit stores are struggling to compete against MSO conglomerates.</li>
          <li>Industry newcomers can’t easily enter the booming U.S. cannabis market.</li>
          <li>Heavily funded chains are scooping up market share.</li>
          <li>Ever-changing regulations are hard to stay on top of and can be expensive to adhere to.</li>
        </ul>
        <a  class="button-outlined --text-white --fade-in-right" data-vertical-ivp-class="--animate"
            href="https://item9labs.app.dealmaker.tech/invitations/1aa03026-7402-4585-8c13-aef7985768b8/view"
            target="_blank">
            <div class="text">Invest Now</div>
            <div class="line -right"></div>
            <div class="line -top"></div>
            <div class="line -left"></div>
            <div class="line -bottom"></div>
          </a>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'InvestEntrepreneurship',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/InvestEntrepreneurship.scss";
</style>
